import React, {Component} from 'react'

class CV extends Component {

    render(){
        const color = this.props.color

        return(
        <div className="CV">
          <h1 className="cv-heading">CURRICULUM VITAE</h1>
            
            <div className={"cv-section" + color}> 
            <p className="sub-heading">SKILLS</p>
            <ul>
            <li>C# Programming</li>
            <li>Javascript Programming</li>
            <li>Java Programming</li>
            <li>C++ Programming</li>
            <li>Electronics design and repair</li>
            <li>SQL Programming</li>
            <li>Good Communication Skills</li>
            </ul>
            </div>

            <div className={"cv-section" + color}>
            <p className="sub-heading">EDUCATION</p>
            <p><b>Institution:</b> University of Johannesburg 01 July 2012</p>
            <p><b>Qualification:</b> National Diploma in Electrical Engineering Light Current</p>
            <p><b>City:</b> Johannesburg</p>
            <p><b>Subjects:</b> Electronics, Radio Engineering, Engineering Projects, Mathematics, Digital Systems</p>
            <br/>
            <p><b>Institution:</b> Umgungundlovu FET College 01 November 2008</p>
            <p><b>Qualification:</b> N6 - Electrical Engineering</p>
            <p><b>City:</b> Pietermaritzburg, KwaZulu Natal</p>
            <p><b>Subjects:</b> Mathematics N6, Power Machines N6, Engineering Science N6, Industrial Electronics N6</p>
            <br/>
            <p><b>Institution:</b> Umgungundlovu FET College 01 December 2007</p>
            <p><b>Qualification:</b> National Certificate</p>
            <p><b>City:</b> Pietermaritzburg, KwaZulu Natal</p>
            <p><b>Subjects:</b> English, Afrikaans, Mathematics, Electro-technology</p>
            </div>

            <div className={"cv-section" + color}>
            <p className="sub-heading">EXPERIENCE</p>
            <p><b>Title:</b> Vista Software Support Consultant</p>
            <p><b>Company:</b> Mangethe Digital Solutions contracted to Ster Kinekor</p>
            <p><b>Duration:</b> 18 July 2018 - 01 April 2019</p>
            <p><b>City:</b> Sandton, Gauteng</p>
            <p><b>Duties:</b> Assisted with installation of Windows server as well as SQL Server software.Implementation of Vista Software installations for customers. Provide training to Ster Kinekor staff with regards to Vista cinema software. Compile and organise training material and manuals for Ster Kinekor on Vista cinema software. Provide IT and software support for customers Compile and create reports using PowerBI and T-SQL for customers. Plan, manage and execute cinema software projects and provide timely reports on their progress.</p>
            <br/>
            <p><b>Title:</b> Vista Software Support Consultant</p>
            <p><b>Company:</b> Mangethe Digital Solutions contracted to Ster Kinekor</p>
            <p><b>Duration:</b> 18 July 2018 - 01 April 2019</p>
            <p><b>City:</b> Sandton, Gauteng</p>
            <p><b>Duties:</b> Assisted with installation of Windows server as well as SQL Server software.Implementation of Vista Software installations for customers. Provide training to Ster Kinekor staff with regards to Vista cinema software. Compile and organise training material and manuals for Ster Kinekor on Vista cinema software. Provide IT and software support for customers. Compile and create reports using PowerBI and T-SQL for customers. Plan, manage and execute cinema software projects and provide timely reports on their progress. Executed SQL queries and compiled sales and attendance reports for customers.</p>
            <br/>
            <p><b>Title:</b> Electronic Technician</p>
            <p><b>Company:</b> Questek Holdings</p>
            <p><b>Duration:</b> 01 November 2011 - 01 April 2016</p>
            <p><b>City:</b> Bryanston, Gauteng</p>
            <p><b>Duties:</b> Installed Audio visual devices such as Epson projectors, projector screens, Extron speakers and controllers. Configured Extron controllers as well as London Soundweb audio processors. Provided assistance and training to customers with regard to audio visual equipment. Installed and maintained Barco OL-7 indoor video-walls as well as CMS software in and around South Africa. Installed and maintained Barco outdoor LED video walls at various sites such as Royal Bafokeng and Orlando stadiums. Conducted site visits and compiled project plans and bill of materials for installations. Installed surveillance cameras as well as training on surveillance equipment to IT personnel at Johannesburg High court. Fault finding on various devices and soldering repair work. Repair and configuration of Wayfarer bus card machines and modules. Working directly with the clients to solve installation or maintenance issues in a timely manner. Communicating effectively with clients, engineers, project managers, and team members regarding installation guidelines and scheduling.</p>
            <br/>
            <p><b>Title:</b> Machine Operator</p>
            <p><b>Company:</b> Unilever food Solutions</p>
            <p><b>Duration:</b> 05 January 2009 - 01 June 2009</p>
            <p><b>City:</b> Pietermaritzburg, KwaZulu Natal</p>
            <p><b>Duties:</b> Ensuring that the machine is operating correctly by utilising monitors and gauges on the equipment; Ensuring that the manufactured part is manufactured according to the correct specifications given; Utilising safe operating procedures during the manufacturing process by following SOPs; Adhering to preventative maintenance procedures by ensuring tools are calibrated at the correct times and by cleaning, greasing and checking the fluids as required by the maintenance department.</p>
            </div>

            <div className={"cv-section" + color}>
            <p className="sub-heading">ACCOMPLISHMENTS</p>
            <p>Support in the provision of Audio Visual System Solutions: I have conducted installations and maintenance of Audio Visual systems: 
                telecommunication equipment; and broadcasting solutions for well- known organisations in South Africa including: Telkom Transnet 
                MTN CSIR Eskom ABSA SA Reserve Bank SABC EOH - Computer Associates. </p>
                <p>Software Development and Support: I have developed Sales 
                Management and Invoicing Software for small to medium businesses. I have also provided software maintenance and support for Ster 
                Kinekor, Control Room and Icebo Solutions.</p>
            </div>
            <br/>
            <div className={"cv-section" + color}>
            <p className="sub-heading">REFERENCES</p>
            <p><b>Name:</b> Cedric Mabuli</p>
            <p><b>Company:</b> Ster Kinekor Entertainment</p>
            <p><b>Position:</b> VISTA Team Manager</p>
            <br/>
            <p><b>Name:</b> Yusuf R Shaik</p>
            <p><b>Company:</b> Control Room and AV Solutions</p>
            <p><b>Position:</b> Senior Technician</p>
            <br/>
            <p><b>Name:</b> Dr Odwa Gulwa</p>
            <p><b>Company:</b> Icebo Solutions</p>
            <p><b>Position:</b> Director</p>
            </div>
        </div>
        )
    }

}

export default CV;